'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Input = require('tg-core-components/lib/components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('tg-core-components/lib/components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _reactIntl = require('react-intl');

var _WithValidation = require('tg-core-components/lib/lib/WithValidation');

var _WithValidation2 = _interopRequireDefault(_WithValidation);

var _required = require('tg-core-components/lib/lib/WithValidation/rules/required');

var _required2 = _interopRequireDefault(_required);

var _translate = require('../../lib/utils/translate');

var _translate2 = _interopRequireDefault(_translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bonus = function (_PureComponent) {
  _inherits(Bonus, _PureComponent);

  function Bonus() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bonus);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bonus.__proto__ || Object.getPrototypeOf(Bonus)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (_ref2) {
      var bonusCode = _ref2.bonusCode;

      _this.props.handleSubmit(bonusCode);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Bonus, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(BonusCodeForm, { onSubmitForm: this.handleSubmit });
    }
  }]);

  return Bonus;
}(_react.PureComponent);

var BonusCodeForm = function BonusCodeForm(_ref3) {
  var errors = _ref3.errors,
      intl = _ref3.intl,
      onSubmit = _ref3.onSubmit;

  return _react2.default.createElement(
    'form',
    { className: 'form', onSubmit: onSubmit },
    _react2.default.createElement(_Input2.default, {
      label: (0, _translate2.default)({
        id: 'label.bonus_code',
        defaultMessage: 'Bonus code'
      }, intl),
      type: 'text',
      name: 'bonusCode',
      status: errors.bonusCode && 'failure' || 'idle',
      statusText: errors.bonusCode && (0, _translate2.default)({ id: errors.bonusCode }, intl)
    }),
    _react2.default.createElement(
      _Button2.default,
      { className: 'button primary wide', type: 'submit' },
      (0, _translate2.default)({
        id: 'label.activate',
        defaultMessage: 'Activate'
      }, intl)
    )
  );
};

var rules = {
  bonusCode: [[_required2.default, 'error.empty.bonusCode']]
};

BonusCodeForm = (0, _compose2.default)((0, _WithValidation2.default)(rules), _reactIntl.injectIntl)(BonusCodeForm);

exports.default = Bonus;